import { IListElementCellBase } from './list-element-cell-base.interface';
import { IListElementCell } from './list-element-cell.interface';

import { IInput } from '../../input.interface';
import { IReflect } from '../../reflect.interface';
import { ISelect } from '../../select.interface';

export interface IListElementControlCell extends IListElementCellBase {
  input?: IInput;
  select?: ISelect;
  reflect?: IReflect;
}

/**
 * Check cell on control type
 *
 * @param cellData
 */
export function isControlCell(
  cellData: IListElementCell,
): cellData is IListElementControlCell {
  return 'select' in cellData || 'input' in cellData || 'reflect' in cellData;
}

/**
 * Get control meta from list cellData
 *
 * @param cellData
 */
export function getCellControl(cellData: IListElementControlCell):
  | {
      control: IInput;
      type: 'input';
    }
  | {
      control: IReflect;
      type: 'reflect';
    }
  | {
      control: ISelect;
      type: 'select';
    } {
  if (cellData.select) {
    return {
      type: 'select',
      control: cellData.select,
    };
  }

  if (cellData.input) {
    return {
      type: 'input',
      control: cellData.input,
    };
  }

  return {
    type: 'reflect',
    control: cellData.reflect!,
  };
}
